import React, { useRef } from "react"
import { Link } from "gatsby"
import { useInView } from "framer-motion"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import './card.css'

const Card = ({ infoTilesContent, hasIconCaret=false, isOverFlow=false }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    return (
        <div ref={ref} className={`flex wrap card-list ${isOverFlow && 'card-overflow'}`}>
            {infoTilesContent && infoTilesContent?.map((item, index) => (
                <div 
                    key={index} 
                    style={{
                        transform: isInView ? "none" : `translateX(-${50 + index}px)`,
                        opacity: isInView ? 1 : 0,
                        transition: `all ${.9 * index}s cubic-bezier(0.17, 0.55, 0.55, 1) ${.9 * index}s`,
                    }}
                    className="relative card-item text-center"
                >
                    <div className="relative z-2 card-inner">
                        <p className="mb-0 bold uppercase card-heading">{item.title}</p>
                        <p className="mb-0">{item.description.description}</p>
                        {item.buttonConfig && item.buttonConfig.map((buttonItem, buttonIndex)=> (
                            <Link 
                                key={buttonIndex}
                                to={buttonItem.buttonLink || ''} 
                                className="flex justify-center py-20 decoration-none" 
                                target={item.openInNewTab ? '_blank' : '_self'}
                                rel={item.isNoFollow ? 'nofollow noopener noreferrer':''}
                            >{buttonItem.buttonName}<span className="relative">{hasIconCaret && '>'}</span></Link>
                        ))}
                        <Link 
                            to={item.buttonLink || ''} 
                            className="py-20" 
                            target={item.openInNewTab ? '_blank' : '_self'}
                            rel={item.isNoFollow ? 'nofollow noopener noreferrer':''}
                        >
                            <GatsbyImage
                                image={getImage(item.image)}
                                alt={`${item.title} card`}
                            />
                        </Link>
                    </div>
                    <p className="mb-0 absolute bottom-5 z-2 left-0 w-full bold card-note">{item.subTitle}</p>
                </div>
            ))}
        </div>
        
    )
}

export default Card